export const api_url = "http://localhost:21578"
export const remote_url = "https://server.pushvault.shop"
